<template>
  <!-- Pie de leyenda desplegable (patrón del demo): "Desplegar leyenda" → contenido por slot. -->
  <div class="lf">
    <button class="lf-btn" :aria-expanded="open" @click="open = !open">
      <b-icon pack="fas" icon="chevron-right" size="is-small" :class="{ rot: open }"></b-icon>
      <span>{{ open ? $t('prm_portfolio_leg_hide_legend') : $t('prm_portfolio_leg_show_legend') }}</span>
    </button>
    <div v-if="open" class="lf-body"><slot></slot></div>
  </div>
</template>

<script>
  export default {
    name: 'PrmPortfolioLegendFooter',
    data: () => ({ open: false }),
  }
</script>

<style lang="scss" scoped>
  .lf { border-top: 1px solid #eef0f3; background: #f9fafb; }
  .lf-btn {
    width: 100%; display: flex; align-items: center; gap: 6px; padding: 6px 12px; background: transparent;
    border: none; cursor: pointer; text-align: left; font-size: 10px; font-weight: 600; color: #3d5570;
  }
  .lf-btn:hover { background: #f0f2f5; }
  .lf-btn ::v-deep .icon { color: #3a6bc8; transition: transform 120ms; }
  .lf-btn ::v-deep .icon.rot { transform: rotate(90deg); }
  .lf-body { padding: 4px 12px 10px; }
</style>
